import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    meta: { title: '订单管理', icon: 'el-icon-s-order' },
    children: [
      { path: 'list', name: 'OrderList', component: () => import('@/views/order/list'), meta: { title: '全部订单' } },
      { path: 'refund', name: 'OrderRefund', component: () => import('@/views/order/refund'), meta: { title: '退款管理' } }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      { path: 'list', name: 'UserList', component: () => import('@/views/user/list'), meta: { title: '乘客列表', icon: 'el-icon-user' } }
    ]
  },
  {
    path: '/driver',
    component: Layout,
    redirect: '/driver/list',
    meta: { title: '司机管理', icon: 'el-icon-truck' },
    children: [
      { path: 'list', name: 'DriverList', component: () => import('@/views/driver/list'), meta: { title: '司机列表' } },
      { path: 'audit', name: 'DriverAudit', component: () => import('@/views/driver/audit'), meta: { title: '入驻审核' } }
    ]
  },
  {
    path: '/station',
    component: Layout,
    redirect: '/station/list',
    meta: { title: '站点管理', icon: 'el-icon-location' },
    children: [
      { path: 'list', name: 'StationList', component: () => import('@/views/station/list'), meta: { title: '站点列表' } },
      { path: 'point', name: 'StationPoint', component: () => import('@/views/station/point'), meta: { title: '乡镇点位' } }
    ]
  },
  {
    path: '/content',
    component: Layout,
    redirect: '/content/banner',
    meta: { title: '运营配置', icon: 'el-icon-picture' },
    children: [
      { path: 'banner', name: 'ContentBanner', component: () => import('@/views/content/banner'), meta: { title: '首页Banner' } },
      { path: 'hotroute', name: 'ContentHotRoute', component: () => import('@/views/content/hotroute'), meta: { title: '热门线路' } }
    ]
  },
  {
    path: '/trip',
    component: Layout,
    children: [
      { path: 'list', name: 'TripList', component: () => import('@/views/trip/list'), meta: { title: '司机行程', icon: 'el-icon-map-location' } }
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/withdraw',
    meta: { title: '财务管理', icon: 'el-icon-wallet' },
    children: [
      { path: 'withdraw', name: 'FinanceWithdraw', component: () => import('@/views/finance/withdraw'), meta: { title: '提现审核' } }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    children: [
      { path: 'index', name: 'Statistics', component: () => import('@/views/statistics/index'), meta: { title: '数据统计', icon: 'el-icon-s-data' } }
    ]
  },
  {
    path: '/complaint',
    component: Layout,
    children: [
      { path: 'list', name: 'ComplaintList', component: () => import('@/views/complaint/list'), meta: { title: '投诉处理', icon: 'el-icon-warning' } }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/admin',
    meta: { title: '系统管理', icon: 'el-icon-setting' },
    children: [
      { path: 'admin', name: 'SystemAdmin', component: () => import('@/views/system/admin'), meta: { title: '管理员' } },
      { path: 'role', name: 'SystemRole', component: () => import('@/views/system/role'), meta: { title: '角色管理' } },
      { path: 'permission', name: 'SystemPermission', component: () => import('@/views/system/permission'), meta: { title: '权限菜单' } },
      { path: 'config', name: 'SystemConfig', component: () => import('@/views/system/config'), meta: { title: '系统配置' } },
      { path: 'log', name: 'SystemLog', component: () => import('@/views/system/log'), meta: { title: '操作日志' } }
    ]
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

export default router
